import { createPortal } from 'react-dom';
import { brandConfig } from '../../config/brands';
import { useMaterialsPanelStore } from '../../stores/materialsPanelStore';
import { useGenerationJobsSafe } from '../generation/state/jobsContext';
import { useIsMobile } from '../../hooks/useIsMobile';
import './MaterialsFloatingOpenButton.css';

/**
 * 素材パネルの展開ツマミ (フローティングボタン)。
 *
 * - 親要素の backdrop-filter が position:fixed の containing block を作る箇所でも
 *   ビューポート右端に貼り付くように body 直下にポータルする
 * - 素材パネルが開いている間は描画しない (パネル側で閉じるボタンを提供するため)
 */
export default function MaterialsFloatingOpenButton() {
  const { open, isOpen, hasNewMaterials } = useMaterialsPanelStore();
  const isMobile = useIsMobile();
  // Seedance 実在人物フィルタの原因素材があるとき、モバイルでは赤枠カードが
  // 画面外で気づきにくいため、ボタンに赤ポッチを出して注意を引く。
  const jobsState = useGenerationJobsSafe();
  const hasFacePrivacyFlagged = (jobsState?.facePrivacyFlagged?.items?.length ?? 0) > 0;

  if (isOpen) return null;

  const assetLabel = brandConfig.labels.material;
  const panelLabel = `${assetLabel}パネル`;

  const button = (
    <button
      type="button"
      className={`materials-floating-open ${isMobile ? 'materials-floating-open--mobile' : ''}`}
      onClick={() => open('manage')}
      aria-label={`${panelLabel}を開く`}
    >
      {isMobile ? (
        <>
          <img src="/bottom_panel_open_fill.svg" alt="" className="materials-floating-icon" />
          <span className="materials-floating-label">{assetLabel}</span>
          {hasFacePrivacyFlagged ? (
            <span className="materials-floating-dot materials-floating-dot--flagged" />
          ) : hasNewMaterials ? (
            <span className="materials-floating-dot" />
          ) : null}
        </>
      ) : (
        <>
          <img src="/layout-sidebar-right-expand.svg" alt={`${panelLabel}を開く`} />
          <span className="materials-floating-vertical-label">{assetLabel}</span>
        </>
      )}
    </button>
  );

  return createPortal(button, document.body);
}
